<div class="multi-post-container" [class.notOne]="post.messages.length > 1">
  @for (msg of post.messages; track msg) {
    <mat-card style="margin-bottom: 8px; padding: 16px" [class.has-error]="hasError(msg)">
      <tg-post-message-item [msg]="msg"></tg-post-message-item>
    </mat-card>
  }
</div>
